export default {"src":"/_next/static/media/sad-squint.81d212e5.svg","height":40,"width":40};